module.exports = __webpack_public_path__ + "static/bluebunnycomf-6c546dedea81c274b72237f6127d4c17.jpeg";